import React from 'react';
import { useTranslation } from 'react-i18next';
import { IS_MESSENGER } from '../config/appVariant';

/** Wordmark on the signed-out screens. Messenger uses its own icon. */
const AuthBrand = () => {
  const { i18n } = useTranslation();

  if (IS_MESSENGER) {
    return (
      <div className="flex flex-col items-center mb-1">
        <img
          src="/messenger-icon.png"
          alt=""
          className="h-16 w-16 rounded-[1.25rem] object-cover shadow-sm"
        />
        <span className="mt-3 font-bold text-xl text-zinc-900 dark:text-zinc-100 tracking-tight">
          Bazzef Messenger
        </span>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center gap-2.5 mb-2">
      <img
        src="/logo.png"
        alt="Bazzef Logo"
        className="h-9 w-9 rounded-xl object-contain shadow-xs"
      />
      <span className="font-bold text-xl text-zinc-900 dark:text-zinc-100 tracking-tight">
        {i18n.language?.startsWith('ar') ? 'بزاف' : 'bazzef'}
      </span>
    </div>
  );
};

export default AuthBrand;
